import { History } from 'history';
import Store from 'repatch';

import State from '../core/State';
import ErrorPresenter from '../service/ErrorPresenter';
import OfferWebApi from '../service/persistent/offer/OfferWebApi';
import { finishMutatingOffer, setOffer, startMutatingOffer } from './../thunk/offer';

class OfferApplicationUsecase {
  private offerWebApi: OfferWebApi;
  private store: Store<State>;
  private history: History;
  private errorPresenter: ErrorPresenter;

  constructor({
    offerWebApi,
    store,
    history,
    errorPresenter,
  }: {
    store: Store<State>;
    history: History;
    offerWebApi: OfferWebApi;
    errorPresenter: ErrorPresenter;
  }) {
    this.store = store;
    this.history = history;
    this.offerWebApi = offerWebApi;
    this.errorPresenter = errorPresenter;
  }

  public applyForOffer = async (offerId: string): Promise<void> => {
    this.store.dispatch(startMutatingOffer());

    let assignment;
    let offer;

    try {
      assignment = await this.offerWebApi.applyForOffer(offerId);
      offer = await this.offerWebApi.getById(offerId);
    } catch (err) {
      this.errorPresenter.showAsFatal(new Error('message.update_offer_has_failed'));

      this.store.dispatch(finishMutatingOffer());

      return;
    }
    this.store.dispatch(setOffer(offer));
    this.store.dispatch(finishMutatingOffer());
    if (offer.matchingFormat == 'competition') {
      // 提案投稿フォームへ飛ばす
      const base = offer.creativeFormats.find((cf) => !cf.resizeBaseId);
      this.history.push(`/creation_sets/${offer.jobId}/creations/a/${assignment.id}/cf/${base!.id}/new`);
    }
  };
}

export default OfferApplicationUsecase;
